import { useToast } from '@chakra-ui/react';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { IStopTypology } from 'models/production/stopTopology.model';
import { useHistory } from 'react-router-dom';
import { createStopTopology } from 'services/api/requests/production';

export const useCreateStopTopology = (body: IStopTypology) => {
	const queryClient = useQueryClient();
	const history = useHistory();
	const toast = useToast();

	return useMutation(() => createStopTopology(body), {
		onSuccess: () => {
			queryClient.invalidateQueries(['tipologiaParadas-list']);
			history.goBack();
			toast({
				title: 'Cadastrado com sucesso!',
				description:
					'Cadastro de tipologia de parada salvo com sucesso.',
				position: 'bottom-left',
				status: 'success',
				duration: 8000,
				isClosable: true,
			});
		},
		onError: (error: any) => {
			if (error.response.data.length > 0) {
				toast({
					title: 'Erro ao cadastrar tipologia de parada!',
					description: error.response.data[0].message,
					position: 'bottom-left',
					status: 'error',
					duration: 8000,
					isClosable: true,
				});
			} else {
				toast({
					title: 'Erro ao cadastrar tipologia de parada!',
					description:
						'Ocorreu um erro ao tentar cadastrar a tipologia de parada, verifique os dados e tente novamente.',
					position: 'bottom-left',
					status: 'error',
					duration: 8000,
					isClosable: true,
				});
			}
		},
	});
};
